import React, { useState } from 'react';
import { PiggyBank, ChevronDown } from 'lucide-react';
import { useT } from '../services/i18n';

const SavingsSummary = ({ savings, testId = 'savings-summary' }) => {
  const { t } = useT();
  const [open, setOpen] = useState(false);
  if (!savings || savings.total <= 0) return null;
  return (
    <div className="bg-green-50 border border-green-200 rounded-lg px-3 py-2" data-testid={testId}>
      <button type="button" onClick={() => setOpen(o => !o)} className="w-full flex items-center justify-between gap-2 text-sm" data-testid={`${testId}-toggle`}>
        <span className="flex items-center gap-2 font-semibold text-green-800"><PiggyBank size={16} /> {t('savings.title')}</span>
        <span className="flex items-center gap-1 font-bold text-green-700"><span data-testid={`${testId}-total`}>{savings.total.toFixed(2)} €</span><ChevronDown size={14} className={`transition-transform ${open ? 'rotate-180' : ''}`} /></span>
      </button>
      {open && (
        <ul className="mt-2 space-y-1 text-xs text-green-800 border-t border-green-200 pt-2" data-testid={`${testId}-details`}>
          {savings.lines.map(l => <li key={l.key} className="flex justify-between" data-testid={`${testId}-line-${l.key}`}><span>{l.label}</span><span>−{l.amount.toFixed(2)} €</span></li>)}
        </ul>
      )}
    </div>
  );
};

export default SavingsSummary;
